import {Base} from "@/api/Base"

export class ReportAdd extends Base {
    path = "report/add"
}